// src/pages/AuthCallback.js (Versão de TESTE para PARAR o fluxo)

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const AuthCallback = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('--- PÁGINA DE TESTE AuthCallback CARREGADA ---');
    const params = new URLSearchParams(location.search);
    
    // Vamos verificar o nome do parâmetro que discutimos
    const token = params.get('token'); 

    if (token) {
      console.log('SUCESSO! O TOKEN FOI RECEBIDO DO COCKPIT:', token);
      console.log('O fluxo foi interrompido aqui de propósito para depuração.');
      console.log('Se você vê o token acima, o Cockpit está funcionando corretamente.');
      
      // A lógica de login e redirecionamento foi REMOVIDA para este teste.
      // auth.login(token);
      // navigate('/');

    } else {
      console.error('ERRO CRÍTICO: Fui redirecionado para o AuthCallback, mas NÃO HÁ um parâmetro "token" na URL.');
      console.error('URL atual:', window.location.href);
    }
  }, [location]);

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4">Página de Teste de Autenticação</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        O fluxo foi pausado aqui de propósito.
      </Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Por favor, abra o console do navegador (F12) para ver os resultados do teste.
      </Typography>
    </Box>
  );
};

export default AuthCallback;